export function NotFound() {
  return (
    <div className="flex h-full min-h-screen flex-col items-center justify-center gap-2 bg-bg-app px-6 text-center">
      <h1 className="text-2xl font-semibold text-text-primary">Página não encontrada</h1>
      <p className="text-sm text-text-secondary">A página que você procura não existe.</p>
    </div>
  );
}
